var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessfullMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.001 0C15.6775 0 0 15.6775 0 35.001C0 54.3244 15.6775 70.002 35.001 70.002C54.3244 70.002 70.002 54.3244 70.002 35.001C70.002 15.6775 54.3244 0 35.001 0ZM53.0119 26.5424L32.4488 47.1784C31.7927 47.8346 30.8446 48.272 29.8964 48.272C28.9482 48.272 28.0007 47.9073 27.344 47.1784L16.9901 36.8239C15.5318 35.3657 15.5318 33.1052 16.9901 31.6465C18.4483 30.1882 20.7088 30.1882 22.1675 31.6465L29.8968 39.3757L47.9077 21.3648C49.366 19.9065 51.6264 19.9065 53.0852 21.3648C54.4703 22.8236 54.4703 25.0839 53.012 26.5423L53.0119 26.5424Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfullMessageIcon);
export default __webpack_public_path__ + "static/media/successfullMessage_icon.85043b1f28758bfad7c2eebbd2c78a23.svg";
export { ForwardRef as ReactComponent };